;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.bgVideo = (function () {
    function mergeOptions (initial, addons) {
      const combined = initial
      for (let p in addons) {
        if (addons.hasOwnProperty(p)) {
          combined[p] = addons[p]
        }
      }
      return combined
    }

    const initialize = function () {
      const options = {
        zIndex: -1,
        autoplay: true,
        loop: true
      }

      const homeMasthead = $('.js-bgVideo.homepage')
      if (homeMasthead) {
        const homeHeader = homeMasthead.closest('header')
        const homeVideoUrl = homeMasthead.attr('data-video-mp4-url')
        const homeVideoUrlWebm = homeMasthead.attr('data-video-webm-url')
        let homeOptions = {}
        if (homeVideoUrl && homeVideoUrlWebm) {
          const bg = homeHeader.css('background-image').slice(4, -1)
          homeOptions = mergeOptions(options,
            {
              webm: homeVideoUrlWebm,
              mp4: homeVideoUrl,
              poster: bg
            }
          )
        }
        homeMasthead.videoBG(homeOptions)
      }

      const storyMasthead = $('.js-bgVideo.storypage')
      if (storyMasthead) {
        const storyHeader = storyMasthead.closest('header')
        const storyVideoUrl = storyMasthead.attr('data-video-mp4-url')
        const storyVideoUrlWebm = storyMasthead.attr('data-video-webm-url')
        let storyOptions = {}
        if (storyVideoUrl && storyVideoUrlWebm) {
          const bg = storyHeader.css('background-image').slice(4, -1)
          storyOptions = mergeOptions(options,
            {
              webm: storyVideoUrlWebm,
              mp4: storyVideoUrl,
              poster: bg
            }
          )
        }
        storyMasthead.videoBG(storyOptions)
      }

      // var genericVideo = $('.has-video .is-video')
      // if (genericVideo) {
      //   var wrapper = genericVideo.closest('.has-video'),
      //     mp4Url = genericVideo.attr('data-video-mp4-url'),
      //     webmUrl = genericVideo.attr('data-video-webm-url')
      //   if (mp4Url && webmUrl) {
      //     var bg = wrapper.css('background-image').slice(4, -1)
      //     var genericVideoOptions = mergeOptions(options, {
      //         webm: webmUrl,
      //         mp4: mp4Url,
      //         poster: bg
      //       }
      //     )
      //     console.log('making video with options: ', genericVideoOptions)
      //     genericVideo.videoBG(genericVideoOptions)
      //   }
      // }

      // make this sucka responsive
      $('.videoBG_wrapper, .videoBG').css('width', '100%')

      // resize video on browser resize
      resizeVideo()

      $(window).on('resize', function (e) {
        resizeVideo()
      })

      function resizeVideo () {
        const $video = $('.videoBG video')
        const videoWidth = $video.width()
        const halfWidth = videoWidth / 2
        const videoHeight = $('.mastheadVideo').height()

        $video.css('margin-left', -halfWidth).css('left', halfWidth)
        $('.videoBG_wrapper, .videoBG').height(videoHeight)
      }
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.bgVideo.initialize()
  })
}(jQuery, window))
